<template>
  <b-taginput v-bind="$attrs" v-on="$listeners" ref="tagInput">
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"/>
    </template>
  </b-taginput>
</template>

<script>
export default {
  name: 'qd-taginput',
  methods: {
    removeTag(index, event) {
      this.$refs.tagInput.removeTag(index, event);
    },
  },
};
</script>
